import "./App.css";
import { Alert, AlertColor, Snackbar } from "@mui/material";
import { useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { HomePage } from "./pages/Home/HomePage";
import { Http } from "./utilities/Http";

interface SnackbarProps {
  open: boolean;
  message: string;
  severity: AlertColor;
}

const DEFAULT_SNACKBAR_STATE: SnackbarProps = {
  open: false,
  message: "",
  severity: "info",
};

function App() {
  const [snackbar, setSnackbar] = useState<SnackbarProps>(
    DEFAULT_SNACKBAR_STATE
  );

  const handleSnackbarClose = () => setSnackbar(DEFAULT_SNACKBAR_STATE);

  const onHttpError = async (response: Response, responseJson: any) => {
    setSnackbar({
      open: true,
      message: responseJson?.message || "Error: unsuccessful request",
      severity: "error",
    });
  };

  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomePage http={new Http(onHttpError)} />,
    },
  ]);

  return (
    <>
      <RouterProvider router={router} />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default App;
